import { ICON__circle_question } from '@/assets/icons_fa';
import { UI_PRIMITIVE__dropdown_menu } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu';
import { UI_PRIMITIVE__dropdown_menu_content } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_content';
import { UI_PRIMITIVE__dropdown_menu_separator } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_separator';
import { UI_PRIMITIVE__dropdown_menu_trigger } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_trigger';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { useState } from 'react';
import { ButtonHelpBug } from './buttons/ButtonHelpBug';
import { ButtonHelpDiscord } from './buttons/ButtonHelpDiscord';
import { ButtonHelpDocs } from './buttons/ButtonHelpDocs';
import { ButtonHelpFeatureRequest } from './buttons/ButtonHelpFeatureRequest';
import { ButtonHelpWriteEmail } from './buttons/ButtonHelpWriteEmail';
import { ButtonHelpWriteMessage } from './buttons/ButtonHelpWriteMessage';
import { ButtonHelpShowAllShortcuts } from './buttons/button_help_show_all_shortcuts';
import { ButtonHelpShowHintsShortcuts } from './buttons/button_help_show_hints_shortcuts';

export function DROPDOWN__help() {
  /*
   * FIELDS
   */

  const { global_need_show_first_animation } = use_slice_ui(['global_need_show_first_animation']);

  const [is_open, set_is_open] = useState(false);

  /*
   * EVENTS
   */

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__dropdown_menu modal={false} open={is_open} onOpenChange={set_is_open}>
      <UI_PRIMITIVE__dropdown_menu_trigger
        className={`hover-animation !h-full ${global_need_show_first_animation ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
        asChild
        onMouseEnter={() => set_is_open(true)}
      >
        <span className="!w-16 !h-4 flex items-center justify-center cursor-pointer">
          <ICON__circle_question className="!w-4 !h-4 text-component-item-foreground hover-animation-important hover:text-bar-foreground" />
        </span>
      </UI_PRIMITIVE__dropdown_menu_trigger>
      <UI_PRIMITIVE__dropdown_menu_content
        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
        onMouseLeave={() => set_is_open(false)}
        align="start"
        side="right"
        sideOffset={4}
      >
        <ButtonHelpDiscord />
        <ButtonHelpDocs />

        <UI_PRIMITIVE__dropdown_menu_separator />

        <ButtonHelpBug />
        <ButtonHelpFeatureRequest />

        <UI_PRIMITIVE__dropdown_menu_separator />

        <ButtonHelpWriteMessage />
        <ButtonHelpWriteEmail />

        <UI_PRIMITIVE__dropdown_menu_separator />

        <ButtonHelpShowAllShortcuts />
        <ButtonHelpShowHintsShortcuts />
      </UI_PRIMITIVE__dropdown_menu_content>
    </UI_PRIMITIVE__dropdown_menu>
  );
}
